import { render, staticRenderFns } from "./LegalEntityReestrImport.vue?vue&type=template&id=3761aca2&scoped=true"
import script from "./LegalEntityReestrImport.vue?vue&type=script&lang=js"
export * from "./LegalEntityReestrImport.vue?vue&type=script&lang=js"
import style0 from "./LegalEntityReestrImport.vue?vue&type=style&index=0&id=3761aca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3761aca2",
  null
  
)

export default component.exports